import LoadingIndicatorProgress from './LoadingIndicatorProgress';
export default LoadingIndicatorProgress;
